import { HashConnect } from "hashconnect";
import { AccountId, TransactionId, ContractExecuteTransaction, ContractFunctionParameters, ContractId } from "@hashgraph/sdk";
import { HashConnectConnectionState } from "hashconnect/dist/types";
import React, { useCallback, useEffect, useState } from "react";
import store from '../store'
import { walletStatusUpdate } from '../pages/connectWalletRedux/connectWalletAction'

//initialize hashconnect
export const hashConnect = new HashConnect();

export const HashConnectAPIContext = React.createContext({
  state: HashConnectConnectionState.Connected,
});

export const HashConnectAPIProvider = ({ children, metaData, network, debug }) => {
  const [state, setState] = useState({
    availableExtension: null,
    state: HashConnectConnectionState.Connected,
    topic: null,
    pairingString: null,
    pairingData: null,
  });

  const initializeHashConnect = useCallback(async () => {

    const initData = await hashConnect.init(metaData, network, false);

    setState((prev) => ({ ...prev, topic: initData.topic }));
    setState((prev) => ({ ...prev, pairingString: initData.pairingString }));

    //Saved pairings will return here, generally you will only have one unless you are doing something advanced
    setState((prev) => ({ ...prev, pairingData: initData.savedPairings[0] }));
  }, [debug, metaData, network]);

  useEffect(() => {
    initializeHashConnect();
  }, []);

  useEffect(() => {
    //This is fired when a extension is found
    hashConnect.foundExtensionEvent.on((data) => {
      if (debug) console.log("============Found extension", data);

      setState((prev) => ({ ...prev, availableExtension: data }));
    });

    //This is fired when a wallet approves a pairing
    hashConnect.pairingEvent.on((data) => {
      if (debug) console.log("============Paired with wallet", data);
      store.dispatch(walletStatusUpdate({ walletAddress: String(data.accountIds[0])}))
      localStorage.setItem('walletAddress', data.accountIds[0]);
      setState((prev) => ({ ...prev, pairingData: data.pairingData }));
    });

    //This is fired when HashConnect loses connection, pairs successfully, or is starting connection
    hashConnect.connectionStatusChangeEvent.on((state) => {
      if (debug) console.log("=============hashconnect state change event", state);

      setState((prev) => ({ ...prev, state: state }));
    });
  }, []);

  return (
    <HashConnectAPIContext.Provider value={{ ...state, setState, network }}>
      {children}
    </HashConnectAPIContext.Provider>
  );
};

const defaultProps = {
  metaData: {
    name: "LX Protocol",
    description: "A NFT Marketplace build on Hedera",
    icon: "https://nft.flexsin.org/static/media/Logo.657b7a0ad22f6f365679.gif",
  },
  network: "testnet",
  debug: true,
};

HashConnectAPIProvider.defaultProps = defaultProps;

export const useHashConnect = () => {
  const value = React.useContext(HashConnectAPIContext);
  const {  pairingData, setState } = value;

  const connectToExtension = async () => {
    //this will automatically pop up a pairing request in the HashPack extension
    hashConnect.connectToLocalWallet();
  };

  const disconnect = async () => {
    hashConnect
      .disconnect(pairingData.topic)
      .then(() => setState((prev) => ({ ...prev, pairingData: null })));
  };

  return { ...value, connectToExtension, disconnect };
};


export default HashConnectAPIProvider;